import { NgFor } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgDocIconComponent, NgDocButtonIconComponent } from '@ng-doc/ui-kit';
function NgDocBreadcrumbComponent_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 0);
  }
}
function NgDocBreadcrumbComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocBreadcrumbComponent_For_1_Conditional_0_Template, 1, 0, "ng-doc-icon", 0);
    i0.ɵɵtext(1);
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ɵ$index_1_r2 = ctx.$index;
    i0.ɵɵconditional(!(ɵ$index_1_r2 === 0) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r1, "\n");
  }
}
let NgDocBreadcrumbComponent = /*#__PURE__*/(() => {
  class NgDocBreadcrumbComponent {
    constructor() {
      this.breadcrumbs = [];
    }
    static {
      this.ɵfac = function NgDocBreadcrumbComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocBreadcrumbComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocBreadcrumbComponent,
        selectors: [["ng-doc-breadcrumb"]],
        inputs: {
          breadcrumbs: "breadcrumbs"
        },
        decls: 2,
        vars: 0,
        consts: [["icon", "chevron-right"]],
        template: function NgDocBreadcrumbComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, NgDocBreadcrumbComponent_For_1_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.breadcrumbs);
          }
        },
        dependencies: [NgDocIconComponent],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;flex-wrap:wrap;gap:var(--ng-doc-base-gutter);margin-bottom:calc(var(--ng-doc-base-gutter) * 2);opacity:.9}[_nghost-%COMP%]   .ng-doc-breadcrumb[_ngcontent-%COMP%]{font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight);display:flex;align-items:center}"],
        changeDetection: 0
      });
    }
  }
  return NgDocBreadcrumbComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocBreadcrumbComponent };
